export default [
  {
    name: 'client-create',
    path: '/clients/create',
    component: () => import('@/views/clients/ClientManage')
  },
  {
    name: 'client-edit',
    path: '/clients/:id/edit',
    component: () => import('@/views/clients/ClientManage')
  },
  {
    name: 'client-view',
    path: '/clients/:id/view',
    component: () => import('@/views/clients/ClientManage')
  },
  {
    name: 'client-find',
    path: '/clients/find',
    component: () => import('@/views/clients/ClientFind')
  },
  {
    name: 'client-contacts',
    path: '/clients/contacts',
    component: () => import('@/views/clients/ContactFind')
  },
  {
    name: 'client-transfer',
    path: '/clients/transfer',
    component: () => import('@/views/clients/transfer/ClientTransfer')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeClients.js